import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { Button, Typography } from 'ui-kit';

const OwnerAlertModal = ({ visible, onCancel, logout }) => (
  <Modal
    visible={visible}
    footer={null}
    style={{ top: '20%' }}
    width="40%"
    maskStyle={{
      background: 'rgba(240, 239, 234, 0.5)',
      backdropFilter: 'blur(15px)',
    }}
    wrapClassName="Store_alert-modal"
    onCancel={onCancel}
  >
    <Typography variant="h5">You are in the shop preview</Typography>
    <p>To add items to your cart, check out, or see full guest view, log out of your store.</p>
    <Button onClick={logout} className="modalButton">
      Log Out
    </Button>
  </Modal>
);

OwnerAlertModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

export default OwnerAlertModal;
